import { render } from "./ScreenSaverView.vue?vue&type=template&id=72f305da&scoped=true"
import script from "./ScreenSaverView.vue?vue&type=script&lang=js"
export * from "./ScreenSaverView.vue?vue&type=script&lang=js"

import "./ScreenSaverView.vue?vue&type=style&index=0&id=72f305da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f305da"]])

export default __exports__